<div mat-dialog-title>
    <div class="page-title-icon">
        <span class="card-header-value dialogue-tittle"> Analysis Request </span>
        <button mat-icon-button class="close-button" (click)="close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
        <div class="subtitle">
            Please select the analysis you wish to carry out on your genome data. You may choose more than one.
        </div>
    </div>
</div>

<mat-dialog-content>
  
    <mat-accordion>
      <mat-expansion-panel *ngFor="let pkg of packageList">
        <mat-expansion-panel-header>
          <mat-checkbox
            [(ngModel)]="pkg.selected"
            [indeterminate]="pkg.indeterminate"
            (change)="togglePackage(pkg)">
            <span>{{ pkg.packageName }}</span>
          </mat-checkbox>
        </mat-expansion-panel-header>
  
        <div class="template-list">
          <mat-checkbox
            *ngFor="let t of pkg.templates"
            [(ngModel)]="t.selected"
            (change)="toggleTemplate(pkg)">
            {{ t.templateName }}
          </mat-checkbox>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button (click)="close()">Close</button>
    <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="selectedCount === 0">Select</button>
</mat-dialog-actions>